<script setup>
import ModulePackageForm from '@frontJs/components/forms/projectManagement/modules/ModulePackageForm.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { modulePackage, modulePackageTypes } = defineProps({
    modulePackage: {
        type: Object,
        required: false,
    },
    modulePackageTypes: {
        type: Array,
        required: true,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title v-if="modulePackage">
            Mettre à jour le forfait module #{{ modulePackage.id }} - Forfaits
            modules Modules - Gestion de projet - Datakepler
        </title>

        <title v-else>
            Créer un forfait module - Forfaits modules - Modules - Gestion de
            projet - Datakepler
        </title>
    </Head>

    <PageTitle v-if="modulePackage">
        Gestion de projet - Modules - Forfaits modules - Mettre à jour le
        forfait module #{{ modulePackage.id }}
    </PageTitle>

    <PageTitle v-else>
        Gestion de projet - Modules - Forfaits modules - Créer un forfait module
    </PageTitle>

    <ModulePackageForm
        :module-package="modulePackage"
        :module-package-types="modulePackageTypes"
    />
</template>
